/// <amd-module name="typeahead/features/LXCategorySuggestion" />
/// <amd-dependency path="jquery" name="$"/>

/// <reference path="../../typings/typeahead/suggestionsProvider.d.ts"/>

import {ClientHandlerRegistry} from "typeahead/client/ClientHandlerRegistry";
import {InputValueEditedMessage} from "typeahead/core/message/InputValueEditedMessage";
import {SuggestionSelectedMessage} from "typeahead/core/message/SuggestionSelectedMessage";
import {TypeaheadMessage} from "typeahead/core/message/TypeaheadMessage";
import * as ExecutionHelper from "typeahead/core/plugins/ExecutionHelper";
import {IStripingConfiguration} from "typeahead/core/StripingConfiguration";
import {IEssSuggestionResult, IExtraSearchParam, ISuggestionResult} from "typeahead/core/Suggestion";
import {Optional} from "typeahead/core/util/Optional";
import {addFeatureFlag} from "typeahead/dataprovider/suggestservice/SuggestServiceQueryParamsUtils";

const configuration: IStripingConfiguration[] = [
    {
        clients: ["Homepage", "AWSHomepage"],
        tabs: ["activity"],
    },
    {
        clients: ["LXLandingPage"],
    },
];

const featureFlag = "lxcategory";

export class LXCategorySuggestion implements IRequestUrlParamModifier, ISuggestionsModifier, IPageLoadHandler {

    public modifyParameters(params: ISuggestServiceQueryParams, context: IContext, options?: any):
        ISuggestServiceQueryParams {
        context.tab = ClientHandlerRegistry.getTab();
        return addFeatureFlag(featureFlag, configuration, params, context, options);
    }

    public modifySuggestions(suggestions: IEssSuggestionResult[], context: IContext, options: any):
        ISuggestionResult [] {
        if (suggestions && suggestions.length > 0) {
            if (ExecutionHelper.shouldExecute(context, configuration)) {
                suggestions.forEach((suggestion: IEssSuggestionResult): void => {
                    if (suggestion.hierarchyInfo) {
                        let relation = suggestion.hierarchyInfo.relation;
                        if (relation && relation[0] === "lxcategory") {
                            suggestion.showAsHierarchy = true;
                        }
                    }
                });
            }
        }
        return suggestions;
    }

    public handlePageLoad(options: any, context: IContext): void {
        TypeaheadMessage.subscribe(
            SuggestionSelectedMessage.getTopic(),
            (topic: string, suggestion: SuggestionSelectedMessage) => {
                context.tab = ClientHandlerRegistry.getTab();
                if (ExecutionHelper.shouldExecute(context, configuration)) {
                    let params: Optional<IExtraSearchParam[]> =
                        suggestion.getSuggestion().getExtraSearchParams();
                    params.orElse([]).forEach((param: IExtraSearchParam) => {
                       let element = document.createElement("INPUT");
                       element.setAttribute("type", "hidden");
                       element.setAttribute("class", "uta-search-parameter");
                       element.setAttribute("name", param.field);
                       element.setAttribute("value", param.value);
                       $("div.tabs-container").find("form:visible").append(element);
                    });
                }
            });
        TypeaheadMessage.subscribe(
            InputValueEditedMessage.getTopic(),
            (topic: string, message: InputValueEditedMessage) => {
                if (ExecutionHelper.shouldExecute(context, configuration)) {
                    $("input.uta-search-parameter").remove();
                }
            });
    }

}
